import { useEffect, useState } from "react";
import {getBatteries, createBattery, deleteBattery} from "./api";
import "./App.css";
// Maybe to deprecate.

function BatteryList() {
	const [batteries, setBatteries] = useState([]);
	const [gbuid, setGbuid] = useState("");

	useEffect(() => {getBatteries().then(setBatteries);}, []);

	const handleCreate = async () => {
		const newBattery = await createBattery({gbuid:gbuid,ah:123,wpc:234,lbuid:"ABC123-U-2026-0001",mfg:"ABC Co",mdl:"Some model"});
		setBatteries((prev) => [...prev, newBattery]);
		setGbuid("");
	};
 
	const handleDelete = async (id) => {
		await deleteBattery(id);
		setBatteries((prev) => prev.filter((battery) => battery.gbuid !== id));
	};
 
	const formatDate = (timestamp) =>
	new Date(timestamp * 1000).toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
	});

	return (
		<>
			<nav>
				<img src="/WT-Full-Logo-Blue@0.5.png" alt="WaveTech Logo" />
				<div className="nav-links">
					<a href="https://www.wavetech.com">WaveTech</a>
					<a href="https://www.wavetech.com/contact">Contact</a>
				</div>
			</nav>

			<main>
				<div style={{display: 'flex', gap: '10px', marginBottom: '30px'}}>
					<input value={gbuid}
						onChange={(e) => setGbuid(e.target.value)}
						placeholder="Enter 19-digit GBUID"
					/>
					<button onClick={handleCreate}>Add Battery</button>
				</div>

				<h1>Battery Specs</h1>
				<ul>
					{batteries.map((battery) => (
						<li key={battery.gbuid}>
							<strong>{battery.gbuid}</strong>
							{battery.oem && (
								<>
									<br />
									<strong>Manufacturer:</strong> {battery.oem.name}
									<br />
									<strong>Model:</strong> {battery.oem.mdl}
								</>
							)}
							{battery.nameplate && (
								<>
									<hr />
									<strong>{battery.nameplate.capacityTitle}:</strong>{" "}
									{battery.nameplate.capacityValue}
									<br />
									<strong>{battery.nameplate.nomVoltageTitle}:</strong>{" "}
									{battery.nameplate.nomVoltageValue}
									<br />
									<strong>{battery.nameplate.standbyUseTitle}:</strong>{" "}
									{battery.nameplate.standbyUseValue}
									<br />
									<strong>{battery.nameplate.cycleUseTitle}:</strong>{" "}
									{battery.nameplate.cycleUseValue}
									<br />
									<strong>{battery.nameplate.maxInitialCurrentTitle}:</strong>{" "}
									{battery.nameplate.maxInitialCurrentValue}
									<br />
									<strong>Local Contact:</strong>{" "}
									{battery.nameplate.localContactName}
									<br />
									<strong>Website:</strong>{" "}
									<a
										href={`https://${battery.nameplate.localContactWebsite}`}
										target="_blank"
										rel="noopener noreferrer"
									>
										{battery.nameplate.localContactWebsite}
									</a>
									<br />
									<strong>CO₂ Recycled:</strong>{" "}
									{battery.nameplate.co2TitlePercentage}%
								</>
							)}
							{battery.events?.length > 0 && (
								<>
									<hr />
									<strong>Latest Event</strong>
									<br />
									Type: {battery.events[0].type}
									<br />
									LBUID: {battery.events[0].lbuid}
									<br />
									Result: {JSON.stringify(battery.events[0].result)}
									<br />
									Date: {formatDate(battery.events[0].date)}
									{battery.events[0].notes && (
										<>
											<br />
											Notes: {battery.events[0].notes}
										</>
									)}
								</>
							)}
							{battery.visual?.image && (
								<>
									<hr />
									<strong>Visual Used:</strong>
									<br />
									<img src={`/visuals/${battery.visual.image}.png`}
										style={{ width: "160px", height: "auto" }}
										onError={(e) => {
											e.target.style.display = "none";
										}}
									/>
								</>
							)}
							{battery.warranty?.length > 0 && (
								<>
									<hr />
									<strong>Warranty</strong>
									<ul>
										{battery.warranty.map((w, index) => (
											<li key={index}>
												{w.type} ({w.warrantor})
												<br />
												Expires: {formatDate(w.expDate)}
											</li>
										))}
									</ul>
								</>
							)}
							<br />
							<button onClick={() => handleDelete(battery.gbuid)}>
								Delete
							</button>
						</li>
					))}
				</ul>
			</main>
		</>
	);
}

export default BatteryList;
